import { create } from 'zustand';

interface DspWarehouse {
  id: string;
  name: string;
}

interface DspWarehouseState {
  dspId: number | null;
  warehouses: DspWarehouse[];
  selectedWarehouseId: string | null;
  setDspId: (id: number | null) => void;
  setWarehouses: (warehouses: DspWarehouse[]) => void;
  setSelectedWarehouseId: (id: string) => void;
}

const useDspWarehouseStore = create<DspWarehouseState>((set) => ({
  dspId: null,
  warehouses: [],
  selectedWarehouseId: null,
  setDspId: (id) => set({ dspId: id }),
  setWarehouses: (warehouses) => set((state) => {
    const newState: Partial<DspWarehouseState> = { warehouses };
    if (state.selectedWarehouseId === null && warehouses.length > 0) {
      newState.selectedWarehouseId = warehouses[0].id;
    }
    return newState;
  }),
  setSelectedWarehouseId: (id) => set({ selectedWarehouseId: id }),
}));

export default useDspWarehouseStore;
